<template>
  <div class="commission-tiers">
    <div class="row">
      <div class="col-md-11">
        <b-button variant="link" class="p-0" pill @click="addNewCommission"
                  :class="{'mb-3': model.commissions && model.commissions.length > 0}">
          <font-awesome-icon :icon="'plus-circle'"/>
          {{ $t('New Commission Tier') }}
        </b-button>
      </div>
    </div>
    <div class="row" v-for="(commission, index) in model.commissions" :key="commission.uuid">
      <div class="col-md-11">
        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col" style="flex: 1">
                <label>
                  {{ $t('Percentage') }}
                  <span class="text-danger">*</span>
                </label>
              </div>
              <div class="col" style="flex: 1;min-width: 3em">
                <percentage-input-widget :label="false" :model="commission" attribute="percent" step="any"/>
              </div>
            </div>
          </div>
          <div class="col-md-6" v-if="index === 0 && showMinimumCommissionField">
            <div class="row">
              <div class="col" style="flex: 1">
                <label>
                  {{ $t('Minimum Commission') }} <span class="text-danger">*</span>
                </label>
              </div>
              <div class="col" style="flex: 1">
                <currency-input-widget :label="false" :model="model" attribute="minimum_commission" step="0.01"/>
              </div>
            </div>
          </div>

          <div class="col-md-6" v-if="index > 0">
            <div class="row">
              <div class="col" style="flex: 1">
                <label>
                  {{ $t('Over') }} <span class="text-danger">*</span>
                </label>
              </div>
              <div class="col" style="flex: 1">
                <currency-input-widget :label="false" :model="commission" attribute="amount_over"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-1 text-left" v-if="index > 0 || (model.commissions.length === 1 && enableFirstTierRemoval)">
        <b-tooltip :target="`remove-commission-button-${index}`" :title="$t('Delete')"/>
        <font-awesome-icon class="text-danger hover-cursor"
                           :id="`remove-commission-button-${index}`"
                           @click="removeCommissionByIndex(index)"
                           style="font-size: 1.5em;margin-top: .2em"
                           :icon="'times'"/>
      </div>
    </div>
  </div>
</template>

<script>
  import PercentageInputWidget from "../../widgets/PercentageInputWidget";
  import CurrencyInputWidget from "../../widgets/CurrencyInputWidget";
  import Commission from "./Commission.model";

  export default {
    name: "CommissionTiers",
    components: {CurrencyInputWidget, PercentageInputWidget},
    props: {
      model: {
        type: Object,
        required: true
      },
      enableFirstTierRemoval: {
        type: Boolean,
        default: false
      },
      showMinimumCommissionField: {
        type: Boolean,
        default: false
      },
    },
    methods: {
      init() {
        this.model.commissions = this.model.commissions.map(data => new Commission(data));

        if (this.model.commissions.length === 0) {
          this.addNewCommission();
        }
      },
      addNewCommission() {
        this.model.commissions.push(new Commission({amount_over: null, percent: ''}));
      },
      removeCommissionByIndex(index) {
        for (let i = 0; i < this.model.commissions.length; i++) {
          if (i === index) {
            this.model.commissions.splice(i, 1);
            break;
          }
        }
      },
    },
    watch: {
      'model'() {
        if (this.model && this.model.commissions) {
          this.init();
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .commission-tiers {
    .form-group {

    }
  }
</style>
